export default __webpack_public_path__ + "static/img-clients-89d385e3ab1b94719d548dcd91c07fc6.svg";